/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    FETCHING_COMMENTING_STATISTICS, RECEIVE_COMMENTING_STATISTICS,
    EXPORTING_COMMENTING_STATISTICS, EXPORT_COMMENTING_STATISTICS
} from 'state/actions/commentingState/statisticsStatus';
//utils


/* ========== ~~~~~~~~~~ STATS STATE > COMMENTS STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const statisticsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case FETCHING_COMMENTING_STATISTICS:
            newState.fetchingCommentingStatistics = action.status;
            return newState;
        case RECEIVE_COMMENTING_STATISTICS:
            newState.commentingStatistics = action.data;
            newState.hasMoreData = action.hasMoreData;
            return newState;
        case EXPORTING_COMMENTING_STATISTICS:
            newState.exportingCommentingStatistics = action.status;
            return newState;
        case EXPORT_COMMENTING_STATISTICS:
            newState.exportingCommentingStatistics = false;
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default statisticsStatus;
